import type { ReactElement } from 'react';
import React, { useCallback } from 'react';

import { Box } from '@zillow/constellation';
import { useYieldCallback } from '@zillow/yield-callback';
import { HomePageCard, HomePageCardWrapper, OnsiteMessage } from '@zillow/zrs-cms-messaging';

import type { getOmpDataQuery } from '../../__generated__/graphql';
import { ompNewLaneProps } from '../../constants/newLane';
import type { RTBCardConfig } from './constants';

const RTBCardLoaded: React.FC<RTBCardLoadedProps> = ({
    card,
    onsiteMessageData = {},
    additionalProps = {},
    showFallback = false,
    index,
}): ReactElement => {
    const onClickAction = useCallback(() => {
        if (card.link) {
            window.open(card.link, '_self');
        }
    }, [card.link]);

    const yieldedOnClickAction = useYieldCallback(onClickAction);
    const emptyYieldedHover = useYieldCallback(() => {});

    return (
        <Box data-testid={`hops-rtb-card-${index}`}>
            {showFallback ? (
                <HomePageCard
                    buttonText={card.buttonText}
                    clickAction={yieldedOnClickAction}
                    hoverAction={() => emptyYieldedHover}
                    defaultImageMedia={card.defaultImageMedia}
                    optimizedImageMedia={card.optimizedImageMedia}
                    description={card.description}
                    headline={card.headline}
                    {...additionalProps}
                    useVisualRefreshTheme
                />
            ) : (
                <OnsiteMessage
                    messageData={onsiteMessageData.onsiteMessage}
                    additionalProps={{
                        ...additionalProps,
                        useVisualRefreshTheme: true,
                    }}
                    placementName={card.placementName}
                    // eslint-disable-next-line zillow/@typescript-eslint/no-unsafe-assignment
                    supportedComponents={{ HomePageCardWrapper }}
                    {...ompNewLaneProps[card.placementName]}
                />
            )}
        </Box>
    );
};

interface RTBCardLoadedProps {
    card: RTBCardConfig;
    onsiteMessageData: getOmpDataQuery;
    additionalProps: Record<string, unknown>;
    showFallback: boolean;
    index: number;
}

export default RTBCardLoaded;
